window.nn.registerModule('flexTool', async function () {
  import(/* webpackChunkName: "flextool" */ './flextool.js');
});